import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useQuery } from '@sequencehq/api/utils'
import { MINUTES } from '@sequencehq/utils/dates'
import { useParams } from 'react-router-dom'
import invariant from 'tiny-invariant'

// Reads the product id from the route and fetches the product via useQuery.
// Several product-page components call this; the shared staleTime dedupes the
// request across them.
export const useProduct = () => {
  const { productId } = useParams<{ productId: string }>()
  invariant(productId, 'productId is required')

  const productQuery = useQuery(
    dashboardv99990101Client.getProduct,
    { id: productId },
    { staleTime: 1 * MINUTES }
  )

  return {
    product: productQuery.data ?? undefined,
    isLoading: productQuery.isPending
  }
}
